<template>
    <div class="container">
    <div class="font_1">
        关于我们
    </div> <br>
        <div class="font_2">{{ $store.state.options.footerText1 }}</div><br>
        <div class="font_2">{{ $store.state.options.footerText2 }}</div>
    </div>
    <el-divider><el-icon><star-filled /></el-icon></el-divider>
    <div class="footer-under">
        <div style="text-align: center; color: rgb(102, 102, 102);">
            © 2024  SCD：版权所有
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.font_1{
    padding-top: 80px;
    font-weight: 550;
    font-size: 35px;
    text-align: center;
    color: rgb(113, 20, 219);
    text-decoration: underline;
    text-decoration-color: rgb(255, 140, 8);
    text-underline-offset: 5px;
}

.font_2 {
    color: rgb(100, 100, 100);
    text-align: center;
    font-size: 20px;
}
.title{
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    margin: 0px auto;
}
    .footer-under {
        background-color: rgb(248, 248, 248);
        width: 100%;
        height: 30px;
    }
</style>